import { GroundCommonContent } from "../../../../modules/content/components/GroundCommonContent/GroundCommonContent";
import { GroundRichText } from "../../../../modules/content/components/GroundRichText/GroundRichText";
import { GroundSection } from "../../../../modules/content/components/GroundSection/GroundSection";
import type { IWysiwygBlockProps } from "./WysiwygBlock.props";

export const WysiwygBlock = ({
  alignment,
  anchorId,
  buttons,
  content,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: IWysiwygBlockProps) => {
  if (!content) return null;
  const hasIntro = Boolean(eyebrow || heading || description || buttons?.length);

  return (
    <GroundSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        {hasIntro ? (
          <GroundCommonContent
            alignment={alignment}
            buttons={buttons}
            description={description}
            eyebrow={eyebrow}
            heading={heading}
          />
        ) : null}
        <GroundRichText
          className="w-full [&_h2]:mt-12 [&_h2]:font-ground-display [&_h2]:text-3xl [&_h2]:font-bold [&_h2]:leading-tight [&_h2:first-child]:mt-0"
          content={content}
        />
      </div>
    </GroundSection>
  );
};

WysiwygBlock.displayName = "Block::WysiwygBlock";
